import { ITenants } from 'types/tenants';

interface WithTenants {
	tenants?: string[];
}

export const replaceTenantsField = (
	arr?: WithTenants[],
	tenants?: ITenants
) => {
	if (arr && tenants?.tenants) {
		for (const audit of arr) {
			audit.tenants?.forEach((tenantId, i) => {
				audit.tenants![i] =
					tenants.tenants?.find((t) => t.id === tenantId)?.name || tenantId;
			});
		}
	}
};
